import { useCallback } from 'react';

export function useZetaDispatchChange(state, dispatch, setState) {
  return useCallback(
    (e) => {
      const _data = { ...state };
      _data[e.target.name] = e.target.value;

      dispatch(setState(_data));
    },
    [dispatch, setState, state]
  );
}

export function useZetaStateChange(state, setState) {
  return useCallback(
    (e) => {
      const _data = { ...state };
      _data[e.target.name] = e.target.value;

      setState(_data);
    },
    [setState, state]
  );
}
/*
module.exports = {
  useZetaDispatchChange,
  useZetaStateChange,
};
*/
